import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

function MyOrderds() {
  const navigate = useNavigate();
  let { oid } = useParams();
  let { oname } = useParams();
  let { ogty } = useParams();

  let server_url = localStorage.getItem("server_url");
  let dealer_id = localStorage.getItem("dealer_id");
  const [show, setShow] = useState(true);
  const [Dealer, setDealer] = useState([]);
  const [quantity, setQuantity] = useState(ogty);

  async function Addtocart() {
    if (!dealer_id) {
      navigate("/Logout");
    }

    if (!quantity) {
      return toast("Please enter QTY");
    }

    if (dealer_id && quantity && oid) {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_id", dealer_id);
      formData.append("product_id", oid);
      formData.append("qty", quantity);
      await axios
        .post(`${server_url}add_cart.php`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          if (response.data.status === "0") {
            setShow(true);
            toast(response.data.error);
            setDealer(response.data.result);
          } else if (response.data.status === "1") {
            navigate("/Mycart");
          } else {
            setShow(true);
            toast("Please Try After SomeTime.");
          }
        })
        .catch((e) => {
          toast("Please Try After Some Time.");
        });
    }
  }
  return (
    <>
      <Header />
      <br />
      <div className="page-content header-clear-medium">
        <div className="card card-style">
          <div className="content mb-0" style={{ padding: "10px" }}>
            {/* Product Dropdown */}
            <div className="input-style has-borders no-icon mb-4">
              <input
                type="text"
                readOnly
                className="form-control validate-text"
                placeholder="Enter Quantity"
                value={oname}
              />
              <label className="color-highlight">Product Name</label>
            </div>

            <div
              className="input-style has-borders no-icon mb-4"
              style={{ width: "98%" }}
            >
              <input
                type="number"
                className="form-control validate-text"
                placeholder="Enter Quantity"
                defaultValue={ogty}
                onChange={(e) => setQuantity(e.target.value)}
                min="1"
              />
              <label className="color-highlight">Quantity</label>
            </div>
            {show ? (
              <div className="col-4 pe-1" style={{ width: "98%" }}>
                <button
                  type="button"
                  onClick={() => {
                    setShow(false);
                    Addtocart();
                  }}
                  style={{ width: "100%" }}
                  className="btn btn-3d btn-m btn-full mb-3 rounded-xl text-uppercase font-900 shadow-s border-red-dark  bg-red-light"
                >
                  Update Product
                </button>
              </div>
            ) : (
              ""
            )}
          </div>

          {Dealer.map((Dealer) => (
            <p style={{ padding: "5%" }}>
              {Dealer.dealer_firm_name
                ? "Name: " + Dealer.dealer_firm_name
                : ""}
              <br />
              {Dealer.dealer_login_mobile
                ? "Number: " + Dealer.dealer_login_mobile
                : ""}
              <br />
              {Dealer.dealer_address ? "Address: " + Dealer.dealer_address : ""}
            </p>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
export default MyOrderds;
